import React, { useState, useEffect } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { authAPI } from '../api/client';
import '../styles/auth.css';

export default function VerifyEmail() {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('verifying'); // verifying | success | error
  const [error, setError]   = useState('');
  const [resending, setResending] = useState(false);
  const [resendDone, setResendDone] = useState(false);

  const token = searchParams.get('token');

  useEffect(() => {
    if (!token) { setStatus('error'); setError('No token found in URL.'); return; }
    authAPI.verifyEmail(token)
      .then(() => {
        localStorage.setItem('emailVerified', '1');
        setStatus('success');
      })
      .catch(err => { setStatus('error'); setError(err.response?.data?.error || 'Verification failed'); });
  }, [token]);

  const resend = async () => {
    setResending(true);
    try {
      await authAPI.resendVerification();
      setResendDone(true);
    } catch (e) {
      setError(e.response?.data?.error || 'Could not resend');
    }
    setResending(false);
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <div className="auth-card-inner">
          <span className="auth-logo">covo</span>

          {status === 'verifying' && (
            <>
              <h1 className="auth-heading">Verifying…</h1>
              <p className="auth-sub">Please wait a moment.</p>
            </>
          )}

          {status === 'success' && (
            <>
              <h1 className="auth-heading">Email verified!</h1>
              <p className="auth-sub">Your email address has been confirmed.</p>
              <Link to="/feed" className="btn-primary" style={{ display: 'block', textAlign: 'center', marginTop: 8, textDecoration: 'none' }}>
                Continue to Covo →
              </Link>
            </>
          )}

          {status === 'error' && (
            <>
              <h1 className="auth-heading">Link expired</h1>
              <p className="auth-sub">{error}</p>
              {localStorage.getItem('token') && !resendDone && (
                <button className="btn-primary" onClick={resend} disabled={resending}>
                  {resending ? 'Sending…' : 'Send a new verification email'}
                </button>
              )}
              {resendDone && <p className="auth-sub" style={{ color: '#2D6B55' }}>Check your inbox for a new link.</p>}
              <p className="auth-link"><Link to="/feed">Go to Covo →</Link></p>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
